import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Spinner, Alert } from "react-bootstrap";

const Footer = () => {
  const [footerData, setFooterData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFooterData = async () => {
      try {
        const response = await fetch("https://ecom-22-fe6311cae608.herokuapp.com/api/footer");
        const data = await response.json();
        
        if (data.success) {
          setFooterData(data.data);
        } else {
          setError(data.message || "Failed to fetch footer data");
        }
      } catch (err) {
        setError("Network error. Please try again later.");
        console.error("Error fetching footer:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchFooterData();
  }, []);

  if (loading) {
    return (
      <footer className="footer-area footer-gradient-bg position-relative z-1 pt-185">
        <div className="shape">
          <span />
        </div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="text-center">
                <Spinner animation="border" role="status">
                  <span className="visually-hidden"></span>
                </Spinner>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }

  if (error) {
    return (
      <footer className="footer-area footer-gradient-bg position-relative z-1 pt-185">
        <div className="shape">
          <span />
        </div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <Alert variant="danger">{error}</Alert>
            </div>
          </div>
        </div>
      </footer>
    );
  }

  if (!footerData || !footerData.isActive) {
    return null; // Don't render if data is not available or footer is inactive
  }

  return (
    <>
      <footer className="footer-area footer-gradient-bg position-relative z-1 pt-185">
        <div className="shape">
          <span />
        </div>
        <div className="container">
          <div className="footer-widget pb-40">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div
                  className="widget newsletter-widget mb-40 wow fadeInUp"
                  data-wow-delay=".30s"
                >
                  <div className="newsletter-content">
                    <div className="site-branding">
                      <Link to="/" className="brand-logo">
                        <img
                          src={footerData.logoUrl}
                          alt="Site Logo"
                        />
                      </Link>
                    </div>

                    <p>
                      {footerData.description}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12">
                <div
                  className="widget social-widget mb-40 wow fadeInUp"
                  data-wow-delay=".25s"
                >
                  <h4 className="widget-title">Connect With Us</h4>
                  <ul className="social-nav">
                    {footerData.socialLinks.map((link) => (
                      <li key={link.id}>
                        <a href={link.url}>
                          <i className={link.icon} />
                          {link.platform}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12">
                <div
                  className="widget social-widget mb-40 wow fadeInUp"
                  data-wow-delay=".25s"
                >
                  <h4 className="widget-title">Contact Us</h4>
                  <ul className="social-nav">
                    {footerData.contactInfo.map((info) => (
                      <li key={info.id}>
                        <a href={info.url} className={info.type === "email" ? "flex items-center gap-2" : ""}>
                          <i className={info.icon}></i>
                          {info.text}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-copyright">
            <div className="row">
              <div className="col-lg-12">
                <div className="copyright-text">
                  <p>{footerData.copyrightText}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;